import React from 'react'

import Icons from './../../../utils/import.icons'

import arrow from './../../../UI/icons/Sidebar/arrow.svg'

interface Props{
    proyecto: any,
    textures: any,
    isSidebarHidden: boolean
    handleHideSidebar: any,
    sidebarBtnSelected: string
    handleOpenVias: any
    handleOpenBeneficios: any
    handleOpenAmenidades: any
    handleOpenEtapas: any
    handleOpenProyecto: any
}

interface State{}

class Sidebar extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
        }
    }

    componentDidMount(){
    }

    render(){
        return(
        <div className='sidebar'>
            <div className="header-logo">
                <img alt="" id="Logo_Proyecto" src={this.props.textures["logo.jpg"]} />
            </div>
            <div className='hide-sidebar' onClick={() => {this.props.handleHideSidebar()}}>
                <img src={arrow} className={this.props.isSidebarHidden ? "collapsed":"showed"}/>
            </div>
            <div className={this.props.isSidebarHidden ? 'sidebar-btn-container-collapsed':'sidebar-btn-container'}>
                <div className={this.props.sidebarBtnSelected === "Vias" ? 'sidebar-btn selected-btn':'sidebar-btn'} onClick={() => {this.props.handleOpenVias("Vias")}}>
                    <img src={this.props.sidebarBtnSelected === "Vias" ? Icons['vias2']:Icons['vias']}/>
                    <div>Vías</div>
                </div>
                <hr />
                <div className={this.props.sidebarBtnSelected === "beneficios" ? 'sidebar-btn selected-btn':'sidebar-btn'} onClick={() => {this.props.handleOpenBeneficios("beneficios")}}>
                    <img src={this.props.sidebarBtnSelected === "beneficios" ? Icons['beneficios2']:Icons['beneficios']}/>
                    <div>Beneficios</div>
                </div>
                <hr />
                <div className={this.props.sidebarBtnSelected === "amenidades" ? 'sidebar-btn selected-btn':'sidebar-btn'} onClick={() => {this.props.handleOpenAmenidades("amenidades")}}>
                    <img src={this.props.sidebarBtnSelected === "amenidades" ? Icons['amenidades2']:Icons['amenidades']}/>
                    <div>Amenidades</div>
                </div>
                <hr />
                <div className={this.props.sidebarBtnSelected === "etapas" ? 'sidebar-btn selected-btn':'sidebar-btn'} onClick={() => {this.props.handleOpenEtapas("etapas")}}>
                    <img src={this.props.sidebarBtnSelected === "etapas" ? Icons['etapas2']:Icons['etapas']}/>
                    <div>Etapas</div>
                </div>
                <hr />
                <div className={this.props.sidebarBtnSelected === "proyecto" ? 'sidebar-btn selected-btn':'sidebar-btn'} onClick={() => {this.props.handleOpenProyecto("proyecto")}}>
                    <img src={this.props.sidebarBtnSelected === "proyecto" ? Icons['proyecto2']:Icons['proyecto']}/>
                    <div>Proyecto</div>
                </div>
                <hr />
                {/* {this.props.children} */}
            </div>
        </div>
        )
    }
}

export default Sidebar 